// Cashier sử dụng cùng Dashboard như app
// Phân quyền được xử lý ở AppLayoutCashier và Topnav
import DefaultDashboard from '../app/dashboards/default';

export default DefaultDashboard;
